import { createContext, useContext } from 'react';

interface GlobalContextProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
  footerHeight: number;
  setFooterHeight: (height: number) => void;
}

export const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const useGlobalContext = (): GlobalContextProps => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};